<template>
  <section
    id="dashboard-ecommerce"
  >
    <b-row
      class="match-height"
    >
      <b-col
        xl="12"
        md="12"
      >
        <b-card
          no-body
        >
          <b-card-header><!-- text-muted -->
            <feather-icon
              icon="ArrowLeftIcon"
              size="28"
              class="cursor-pointer"
              @click="$router.push({ name: 'tablero-indicadores' })"
            />
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col
                sm="12"
              >
                <b>Nombre: </b> {{ descripcionEncuesta }}
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col
                sm="12"
              >
                <b>Documentación del indicador</b>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      class="match-height"
    >
      <b-col
        sm="12"
      >
        <b-card
          no-body
        >
          <div
            v-if="isLoading1 === true"
            class="text-center"
          >
            <img
              :src="imageLoading"
              width="400"
            >
          </div>
          <div id="chart">
            <div
              id="divGraficoD1"
              style="margin-left: 35%;"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      class="match-height"
    >
      <b-col
        sm="12"
      >
        <b-card
          no-body
        >
          <div id="chart2">
            <div
              id="divGrafico4"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import store from '@/store'
import router from '@/router'
import {
  BRow, BCol, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import ApexCharts from 'apexcharts'
import imgLoading from '../../../assets/images/dappsa/loading.gif'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
  },
  data() {
    return {
      imageLoading: imgLoading,
      isLoading1: false,
      isLoading2: false,
      data: [],
      torta: false,
      barraHorizontal: false,
      barraVertical: false,
      tipoGrafico: 0,
      descripcionEncuesta: '',
      // series: [], // [44, 55, 13, 43, 22],
      chtClassReport1: null,
      chartOptionsReport1: {
        series: [],
        chart: {
          width: 450,
          type: 'pie',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              // console.log(chartContext, config)
              console.log(config) // dataPointIndex
            },
          },
        },
        labels: [], // ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
      },
      chtClassReport2: null,
      chartOptionsReport2: {
        series: [],
        chart: {
          // height: 350,
          type: 'bar',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              // console.log(chartContext, config)
              // console.log(config) // dataPointIndex
              // console.log(chartContext)
              console.log(config) // dataPointIndex
            },
          },
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              // colors: colors,
              fontSize: '12px',
            },
          },
        },
      },
      chtClassReport3: null,
      chartOptionsReport3: {
        series: [],
        chart: {
          type: 'bar',
          // height: 350,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              // console.log(chartContext, config)
              console.log(config) // dataPointIndex
              // this.loadSub(config.dataPointIndex)
            },
          },
        },
        // colors: ['#26A0FC', '#26E7A6', '#FF4560', '#6ce6f4'],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            distributed: true, // PARA COLORS Y NOMBRE
          },
        },
        tooltip: {
          y: {
            formatter: val => `${val.toFixed(2)} %`,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              // colors: colors,
              fontSize: '12px',
            },
          },
        },
      },
      chtClassReport4: null,
      chartOptionsReport4: {
        series: [],
        chart: {
          type: 'bar',
          // height: 750,
        },
        // colors: ['#26A0FC', '#26E7A6', '#FF4560', '#6ce6f4'],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            // distributed: true, // PARA COLORS Y NOMBRE
          },
        },
        tooltip: {
          y: {
            formatter: val => `${val.toFixed(2)} %`,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            minWidth: 140,
            style: {
              // colors: colors,
              fontSize: '12px',
              minWidth: 440,
            },
          },
        },
      },
    }
  },
  async mounted() {
    await this.loadReport1()
    await this.loadReport2()
  },
  methods: {
    loadSub(index) {
      console.log(index)
      this.$router.push({ name: 'tablero-indicadores-detalle' })
      // this.isSubActive = true
    },
    async loadReport1() {
      this.isLoading1 = true
      const id = Number(router.currentRoute.params.id)
      switch (id) {
        case 72: this.torta = true; this.descripcionEncuesta = 'Porcentaje de solicitudes de los inversionistas que cumple con los requisitos establecidos en el protocolo.'; break
        case 75: this.barraHorizontal = true; this.descripcionEncuesta = 'Porcentaje de Convenios de Alianzas Público Privadas implementados.'; break
        case 76: this.barraVertical = true; this.descripcionEncuesta = 'Porcentaje de aliados o socios comerciales que cumplen con los compromisos asumidos en los contratos de colaboración empresarial para la producción y comercialización'; break
        default: this.descripcionEncuesta = 'Indicador no Válido'; break
      }
      await store
        .dispatch('gsencuesta/TABLERO_INDICADOR_REPORT_1', {
          idEncuesta: id,
        })
        .then(response => {
          if (response !== undefined) {
            let totalSP = (response.total !== 0) ? (response.totalSi * 100) / response.total : 0
            let totalNP = (response.total !== 0) ? (response.totalNo * 100) / response.total : 0
            totalSP = Number(totalSP)
            totalNP = Number(totalNP)
            this.data = [
              { id: 1, total: totalSP, descripcion: 'SI CUMPLE' },
              { id: 2, total: totalNP, descripcion: 'NO CUMPLE' },
            ]
            const r1 = []
            const r2 = []
            this.data.forEach(dat => {
              r1.push(dat.total)
              r2.push(dat.descripcion)
            })
            this.chartOptionsReport1.series = r1
            this.chartOptionsReport1.labels = r2
            this.chartOptionsReport1 = new ApexCharts(document.querySelector('#divGraficoD1'), this.chartOptionsReport1)
            this.chartOptionsReport1.render()
            this.isLoading1 = false
          }
        })
        .catch(() => {
          this.isLoading1 = false
        })
    },
    async loadReport2() {
      this.isLoading2 = true
      const id = Number(router.currentRoute.params.id)
      switch (id) {
        case 72: this.torta = true; this.descripcionEncuesta = 'Porcentaje de solicitudes de los inversionistas que cumple con los requisitos establecidos en el protocolo.'; break
        case 75: this.barraHorizontal = true; this.descripcionEncuesta = 'Porcentaje de Convenios de Alianzas Público Privadas implementados.'; break
        case 76: this.barraVertical = true; this.descripcionEncuesta = 'Porcentaje de aliados o socios comerciales que cumplen con los compromisos asumidos en los contratos de colaboración empresarial para la producción y comercialización'; break
        default: this.descripcionEncuesta = 'Indicador no Válido'; break
      }
      await store
        .dispatch('gsencuesta/TABLERO_INDICADOR_REPORT_2', {
          idEncuesta: id,
        })
        .then(response => {
          if (response !== undefined) {
            const rs = []
            const rn = []
            const r2 = []
            response.fichas.forEach(dat => {
            // const totalSP = (response.total !== 0) ? (response.totalSi * 100) / response.total : 0
            // const totalNP = (response.total !== 0) ? (response.totalNo * 100) / response.total : 0
              let totalSP = 0
              let totalNP = 0
              totalSP = (response.total !== 0) ? (dat.cantidadSi * 100) / response.total : 0
              totalNP = (response.total !== 0) ? (dat.cantidadNo * 100) / response.total : 0
              rs.push(totalSP)
              rn.push(totalNP)
              r2.push(dat.descripcion)
            })
            this.chartOptionsReport4.series.push({
              name: 'SI CUMPLE',
              data: rs,
            })
            this.chartOptionsReport4.series.push({
              name: 'NO CUMPLE',
              data: rn,
            })
            this.chartOptionsReport4.xaxis.categories = r2
            this.chartOptionsReport4 = new ApexCharts(document.querySelector('#divGrafico4'), this.chartOptionsReport4)
            this.chartOptionsReport4.render()
            this.isLoading2 = false
          }
        })
        .catch(() => {
          this.isLoading2 = false
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
